<template>
  <teamPage :key="$route.path"/>
</template>

<script>
import teamPage from './teamPage' 

export default {
  name: 'teamPagePar',
  data(){
      return{
        
        }
  },
  async mounted(){
    
  },

  components: {
      teamPage,
  },
  props: {},
  methods : {
    
    },

}

</script>

<style scoped>

</style>
